ENV = require "config/env"
request = require "superagent"
module.exports =
	getEndPoint: (contentType, pageID="") ->
		return ENV.serverURI + ENV.APIURI + contentType + "/" + pageID
	
	getContent: (endPoint, container, filter="") ->
		if container.loading or container.content isnt null then return
		container.loading = true
		request
			.get endPoint
			.query filter
			.end (err, res) ->
				container.loading = false
				container.totalPages = []
				for i in [0...res.header["x-wp-totalpages"]] then container.totalPages.push(i+1)
				container.content = res.body
	
	####
	getProjectID: (projectSlug) ->
		switch projectSlug
			when "project01" then return 9
			when "project02" then return 10
			when "project03" then return 11
			when "supervision" then return 12
		return ""
	getArchivePostType: (pageSlug) ->
		for archive in ENV.archives then if archive.slug is pageSlug then return archive.contentType
	
	getPageObject: (pageSlug) ->
		for page in ENV.pages then if page.slug is pageSlug then return page
		return null
	
	getCategoryID: (categorySlug) ->
		for category in ENV.categories then if category.slug is categorySlug then return category.id
		return null

	getCategorySlug: (categoryID) ->
		for category in ENV.categories then if category.id is categoryID then return category.slug
		return null

	hasCategory: (post, categoryID)->
		for cat in post.categories then if cat is categoryID then return true
		return false

	getCategoryFillter: (categoryID) ->
		return "categories[]="+categoryID

	getExcludeCategoriesFillter: (activeCategory, categories) ->
		return this.getExcludeCategoriesQuery(activeCategory, [ENV.categories[0], ENV.categories[1], ENV.categories[2], ENV.categories[3]])

	
	####

	date: (post, isEnglish=false) ->
		if post.acf.displayDate? and post.acf.displayDate isnt ""
			if isEnglish then return post.acf.displayDateEn else post.acf.displayDate
		return post.date.split("T")[0].replace(/-/g,".")

	isNew: (post) ->
		date = new Date(post.date)
		today = new Date()
		timeDiff = today.getTime() - date.getTime()
		dateDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))
		return dateDiff <= 3

	excerpt: (post) -> 
			if post.acf.excerpt? then return post.acf.excerpt.replace("<br>","")
			return ""

	####

	getExcludeCategoriesQuery: (activeCategoryID, categories) ->
		excludes = []
		for category in categories
			if category.id is activeCategoryID then continue
			excludes.push category.id
		query = ""
		for id, index in excludes
			query += "categories_exclude[]=" + id
			if index < excludes.length - 1 then query += "&"
		return query


// WEBPACK FOOTER //
// ./src/scripts/wordpress.coffee